var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1663 5.59968V4.39016L10.3122 5.24662L4.39606 11.1795C4.396 11.1795 4.39594 11.1796 4.39588 11.1796C4.35354 11.2219 4.32116 11.233 4.27428 11.233C4.22738 11.233 4.19551 11.2219 4.15375 11.18L4.15316 11.1795C4.11074 11.137 4.09961 11.1046 4.09961 11.0577C4.09961 11.0108 4.11067 10.9789 4.15257 10.9372L4.15266 10.9371L10.086 5.02039L10.9425 4.16634H9.73294H4.66628C4.60357 4.16634 4.57428 4.15057 4.5445 4.12079C4.51477 4.09107 4.49946 4.06237 4.49961 4.00086H4.49961V3.99968C4.49961 3.93697 4.51538 3.90768 4.54516 3.8779C4.57488 3.84817 4.60358 3.83286 4.6651 3.83301V3.83301H4.66628H11.3329C11.3956 3.83301 11.4249 3.84878 11.4547 3.87856C11.4844 3.90829 11.4998 3.93698 11.4996 3.9985V3.99968V10.6663C11.4996 10.729 11.4838 10.7583 11.4541 10.7881L11.8076 11.1417L11.4541 10.7881C11.4243 10.8178 11.3956 10.8332 11.3341 10.833H11.3329C11.2702 10.833 11.2409 10.8172 11.2112 10.7875C11.1814 10.7577 11.1661 10.729 11.1663 10.6675V10.6663V5.59968ZM3.99961 3.99968C3.99961 3.81079 4.06361 3.65234 4.19161 3.52434C4.31961 3.39634 4.47783 3.33257 4.66628 3.33301H11.3329C11.5218 3.33301 11.6803 3.39701 11.8083 3.52501C11.9363 3.65301 12.0001 3.81123 11.9996 3.99968H3.99961Z",
    fill: "black",
    stroke: "#0B93E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.97b121ff58e15df1d27fb0486b15919b.svg";
export { ForwardRef as ReactComponent };